import { useMemo } from "react";
import { useProjectStore } from "src/stores/projectStore";
import { useSeriesStore } from "src/stores/seriesStore";
import { createPOVTenseObject } from "../../../../../src/shared/constants";
import { normalizeIsMultiplePOVState } from "../../../../../src/shared/utils/isMultiplePOVState";

// The header follows selection; rendered chapters supply their outline owner
// while replacement loads. Neither should change the open manuscript's mode.
export const useOutlinePOVTense = (outlineProjectId?: string) => {
  const project = useProjectStore((state) => state.project);
  const projectSettings = useProjectStore((state) => state.povTense);
  const projectMode = useProjectStore((state) => state.isMultiplePOV);
  const selectedId = useSeriesStore((state) => state.selectedSeriesProjectId);
  const projectId = project?.seriesId ? outlineProjectId || selectedId || project.id : project?.id;
  const selectedEntry = useSeriesStore((state) => state.contents.find((entry) => entry.projectId === projectId));
  const settings = project?.seriesId ? selectedEntry?.povTense : projectSettings;
  const povTense = useMemo(() => createPOVTenseObject(settings?.pov, settings?.tense), [settings]);

  return {
    projectId,
    settingsReady: !project?.seriesId || !!selectedEntry,
    isActiveProject: projectId === project?.id,
    povTense,
    isMultiplePOV: normalizeIsMultiplePOVState(project?.seriesId ? selectedEntry?.isMultiplePOV : projectMode),
  };
};
